export default __webpack_public_path__ + "static/media/flag-ie.99c21b30.svg";